import React from "react";

const StepIndicator = ({ currentStep, t }) => {
  const steps = [
    { number: 1, title: t("booking_details") || "Booking Details" },
    { number: 2, title: t("additional_items") || "Additional Items" },
    { number: 3, title: t("customer_info") || "Customer Info" },
    { number: 4, title: t("review_n_confirm") || "Review & Confirm" },
    { number: 5, title: "Payment" },
  ];

  return (
    <div className="w-full px-4 py-6">
      <div className="flex items-center justify-between max-w-4xl mx-auto">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all ${
                  currentStep >= step.number ? "bg-[#f5272b] text-white" : "bg-gray-300 text-gray-600"
                }`}
              >
                {currentStep > step.number ? "✓" : step.number}
              </div>

              <span
                className={`mt-2 h-10 flex items-center justify-center text-xs md:text-sm font-medium text-center leading-tight ${
                  currentStep >= step.number ? "text-[#f5272b]" : "text-gray-500"
                }`}
              >
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-1 flex-1 mx-1 md:mx-2 mb-6 transition-all ${
                  currentStep > step.number ? "bg-[#f5272b]" : "bg-gray-300"
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
